import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'

import axios from '../../dataClient/dataClient'
import { FlexEndButtonErrorContainer } from '../styles/Containers'
import { ErrorText } from '../styles/Text'
import Button, { SecondaryButton } from '../common/Button'

const typeMap = {
  convert: { path: 'category', buttonLabel: 'Convert Files to PDF', errorText: 'start conversion workflow' },
  findDuplicates: { path: 'category', buttonLabel: 'Determine Duplicate Groups', errorText: 'start determining duplicates workflow' },
  suggestRedactions: { path: 'category', buttonLabel: 'Suggest Redactions', errorText: 'start suggesting redactions workflow' },
  applyRedactions: { path: 'category', buttonLabel: 'Finalize Redactions', errorText: 'start finalizing redactions workflow' },
  sendToResponse: { path: 'category', buttonLabel: 'Add to Response', errorText: 'add files to response' },
  removeFromResponse: { path: 'category', buttonLabel: 'Remove from Response', errorText: 'remove files from response' },
  cancel: { path: 'workflow', buttonLabel: 'Cancel', errorText: 'cancel workflow' }
}

function CategoryActionButton({ id, type, onSuccess = () => {}, additionalButtonText = '' }) {
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState()

  function sendRequest() {
    setLoading(true)
    setError(false)

    axios
      .post(`/${typeMap[type].path}/${id}/${type}`)
      .then(({ data }) => onSuccess(data.data))
      .catch(e => {
        console.error(`Failed to ${typeMap[type].errorText}`, e)
        setError(true)
      })
      .finally(() => setLoading(false))
  }

  const ButtonComponent = ['removeFromResponse', 'cancel'].includes(type) ? SecondaryButton : Button

  useEffect(() => {
    setLoading(false)
    setError(false)
  }, [type])

  return (
    <FlexEndButtonErrorContainer gap="5px">
      <ButtonComponent onClick={sendRequest} loading={loading}>
        {typeMap[type].buttonLabel}
        {additionalButtonText}
      </ButtonComponent>
      {error && <ErrorText role="alert">Hm, an error occurred. Try again.</ErrorText>}
    </FlexEndButtonErrorContainer>
  )
}

CategoryActionButton.propTypes = {
  id: PropTypes.string.isRequired,
  type: PropTypes.oneOf(['convert', 'findDuplicates', 'suggestRedactions', 'applyRedactions', 'sendToResponse', 'removeFromResponse', 'cancel'])
    .isRequired,
  onSuccess: PropTypes.func,
  additionalButtonText: PropTypes.string
}

export default CategoryActionButton
